
export default function initStatements() {
    // If no statement marker in dom exit function
    if (!document.querySelector("#statements-marker")) return;

    // Bind events
    bindStatementList();
}

function bindStatementList() {
    $(".fn-toggle-statements").click(function () {
        // Hide all statements
        $(".fn-statment-months").slideUp();
        $(".fn-statement-parent").removeClass("active");

        // Show statements for selected year if not already active
        var statementItem = $(this).next(".fn-statment-months");
        if (!statementItem.is(":visible")) {
            statementItem.slideDown();
            statementItem.closest(".fn-statement-parent").addClass("active");
        }
    });
}